import { useEffect } from 'react'
import { useStoreActions } from '@mortgage-pos/ui/store'

export const useFetchUserLocation = () => {
  const { getUserLocation } = useStoreActions((state) => state.address)

  useEffect(() => {
    async function fetchUserLocation() {
      await getUserLocation()
    }
    fetchUserLocation()
  }, [getUserLocation])
}

export default useFetchUserLocation
